import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { PaperViewer } from "../components/PaperViewer";

export default function PaperView() {
  const { id } = useParams();
  const [paper, setPaper] = useState(null);

  const load = () => api.get(`/papers/${id}`).then((r) => setPaper(r.data)).catch(() => {});

  useEffect(() => { load(); }, [id]);

  const handleChange = async (data) => {
    if (data) setPaper(data);
    else await load();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="paper-view-page">
      <Link to="/my-papers" data-testid="back-to-papers-link" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6">
        <ArrowLeft className="h-4 w-4" /> Back to Saved Papers
      </Link>
      {paper ? <PaperViewer paper={paper} editable onChange={handleChange} /> : (
        <div className="min-h-[40vh] flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
      )}
    </div>
  );
}
